import React from "react";
import LottieAnimation from "../helpers/LottieAnimation";

function LoadingPage() {
  return (
    <div className="flex h-[80vh] items-center justify-center">
      <LottieAnimation type="loading" height="40%" width="40%" />
    </div>
  );
}

export default LoadingPage;
